import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
  appRequestSelector,
  uownSessionIdSelector,
  blackboxIdSelector,
  koalafiNeuroIdSelector
} from "containers/MultistepForm/selectors";
import { selectOffer } from "containers/MultistepForm/actions";

import AdditionalInfoBlock from "components/DataDisplay/AdditionalInfoBlock"; 
import { selectedOfferSelector } from '../../selectors';

import "./styles.scss";

class BankDataForm extends Component {

  state = {
    additionalData: {},
    valid: false
  }

  buildBodyToInitApplication = () => {
    const { additionalData } = this.state;
    const { appRequest, selectedOffer } = this.props;

    const applicationRequest = this.props.offer
    applicationRequest.has_additional_info = true;
    applicationRequest.additional_info_data = {};
    if(additionalData.routingNum && additionalData.accountNum ){
      applicationRequest.bank_data_is_required = false;
      applicationRequest.additional_info_data.bankAccount = {
        routing: additionalData.routingNum,
        account: additionalData.accountNum,
        type: 'checking',
        ...(additionalData.cardBin && { cardBin: additionalData.cardBin })
      }
    }

    // For uown provider, include all application data for resubmit
    if (selectedOffer.provider === 'uown') {
      return {
        ...applicationRequest,
        personalInfo: appRequest.personalInfo,
        residenceInfo: appRequest.residenceInfo,
        employmentInformation: appRequest.employmentInformation,
        // device / behavioral session ids live at the leaseForm root, not in applicationRequest
        uownSessionId: this.props.uownSessionId,
        blackboxId: this.props.blackboxId,
        koalafi_neuro_id: this.props.koalafiNeuroId
      };
    }

    return applicationRequest;
  }
  
  submitForm = (e) => {
    const { valid } = this.state;
    e.preventDefault();
    if (valid) {
      this.props.selectOffer({selectedOffer: this.buildBodyToInitApplication()});
    }
  };

  setAdditionalData = (data) => {
    this.setState({
      additionalData: data.data,
      valid: data.valid
    });
  }

  render() {
    const { loading, selectedOffer, activeStepData } = this.props;
    const { valid } = this.state;

    return (
      <div className="additional-info-step flex flex--column flex__align--center ">
        <div className="paypair-step-content">
          <div className="additional-info-step__form-block">
            <div className="additional-info-step__form-block-title">
              BANK ACCOUNT INFORMATION
            </div>
            <div className="additional-info-step__form-block-content">
              {activeStepData.error && activeStepData.message && (
                <div className="step-message error-message">
                  <p className="text-center">{activeStepData.message || ''}</p>
                </div>
              )}
              <AdditionalInfoBlock
                onDataChange={this.setAdditionalData}
                providerName={selectedOffer.specific_provider_name}
              />
            </div>
          </div>
       
          <BlueBtn customClass="additional-info-step__submit-btn"
            disabled={!valid}
            loading={loading}
            onClick={this.submitForm}
          >
            {selectedOffer.specific_provider_name === 'snap' ? 'CONTINUE' : 'SUBMIT'}
          </BlueBtn>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
  selectedOffer: selectedOfferSelector()(state),
  activeStepData: activeStepDataSelector()(state),
  appRequest: appRequestSelector()(state),
  uownSessionId: uownSessionIdSelector()(state),
  blackboxId: blackboxIdSelector()(state),
  koalafiNeuroId: koalafiNeuroIdSelector()(state)
});


const mapDistpatchToProps = dispatch => {
  return {
    selectOffer: (data) => dispatch(selectOffer(data))
  };
};

BankDataForm = connect(
  mapStateToProps,
  mapDistpatchToProps
)(BankDataForm);

export default BankDataForm;
